import Container from './styles/Container';
import type bannerType from '../../../types/bannerType';

type Props = {
  color?: string;
  bgColor?: string;
  bannerType: bannerType;
  isNewBoostBanner?: boolean;
};

const Value: FC<Props> = ({
  children,
  color = 'text-bulma',
  bgColor = 'bg-gohan',
  bannerType,
  isNewBoostBanner,
}) => {
  if (isNewBoostBanner) {
    return (
      <div className="text-[9px] font-semibold leading-3 text-goten">
        {children}
      </div>
    );
  }

  return (
    <Container color={color} bgColor={bgColor} bannerType={bannerType}>
      {children}
    </Container>
  );
};

export default Value;
